import { render, staticRenderFns } from "./ImportPermits.vue?vue&type=template&id=133ff8d4"
import script from "./ImportPermits.vue?vue&type=script&lang=js"
export * from "./ImportPermits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports